import { useCallback } from 'react';
import { set } from 'lodash/fp';
import { Intervention, PathwayIntervention, AllStop } from '@/types';
import { StopTable } from '@/components/stop-table';

const Detail = (props: DetailProps) => {
  const { intervention, onUpdate } = props;
  const onUpdateReductions = useCallback(
    (v: AllStop) => {
      onUpdate(set('reductions', v));
    },
    [onUpdate],
  );
  const onUpdateFactors = useCallback(
    (v: AllStop) => {
      onUpdate(set('factors', v));
    },
    [onUpdate],
  );

  if (intervention.type === 'grid-decarbonisation') {
    return (
      <StopTable
        stops={intervention.factors}
        heading={`Emissions Factor (kg\u00A0CO\u2082‑e)`}
        onChange={onUpdateFactors}
      />
    );
  }
  if (intervention.type === 'grid-decarbonisation-percentage') {
    return (
      <StopTable
        stops={intervention.factors}
        heading={`% reduction in emissions factor`}
        onChange={onUpdateFactors}
      />
    );
  }
  if (intervention.type === 'building-efficiency') {
    return (
      <StopTable
        stops={intervention.reductions}
        heading='% reduction in energy use'
        onChange={onUpdateReductions}
        unit='%'
      />
    );
  }

  if (intervention.type == 'building-electrification') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Electrification of stationary gas use in existing buildings'
        unit='%'
      />
    );
  }
  if (intervention.type == 'new-building-standards') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Improved sustainability standards in new buildings'
        unit='%'
      />
    );
  }
  if (intervention.type == 'mode-shift-to-public-transport') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Proportion of car trips that are replaced by public transport'
        unit='%'
      />
    );
  }
  if (intervention.type == 'mode-shift-to-active-transport') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Proportion of car trips that are replaced by active transport'
        unit='%'
      />
    );
  }
  if (intervention.type == 'electric-vehicle-takeup') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Proportion of all cars that are electric'
        unit='%'
      />
    );
  }
  if (intervention.type == 'road-to-rail-freight-mode-shift') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Proportion of freight diverted from road to rail'
        unit='%'
      />
    );
  }
  if (intervention.type == 'rail-freight-efficiency') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='% improvement of rail efficiency'
        unit='%'
      />
    );
  }
  if (intervention.type == 'air-transport-efficiency') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='% improvement of air transport efficiency'
        unit='%'
      />
    );
  }
  if (intervention.type == 'waste-reduction') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in waste generation'
        unit='%'
      />
    );
  }
  if (intervention.type == 'waste-diversion-from-landfill') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Proportion of recyclable material that is recovered and diverted from landfill'
        unit='%'
      />
    );
  }
  if (intervention.type == 'waste-treatment') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in waste emissions'
        unit='%'
      />
    );
  }
  if (intervention.type == 'wastewater-treatment') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in wastewater emissions'
        unit='%'
      />
    );
  }
  if (intervention.type == 'industrial-processes') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in industrial process related emissions'
        unit='%'
      />
    );
  }
  if (intervention.type == 'product-use') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in product use related emissions'
        unit='%'
      />
    );
  }
  if (intervention.type == 'livestock') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in livestock related emissions'
        unit='%'
      />
    );
  }
  if (intervention.type == 'horticulture') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Reduction in horticulture related emissions'
        unit='%'
      />
    );
  }
  if (intervention.type == 'exotic-forest-change') {
    return (
      <StopTable
        stops={intervention.reductions}
        onChange={onUpdateReductions}
        heading='Exotic forest change'
        unit='%'
      />
    );
  }
  return null;
};

export type DetailProps = {
  intervention: Intervention | PathwayIntervention;
  onUpdate: (f: (v: any) => any) => void;
};

export { Detail };
